export const COLLABORATIONS_DATA = {
  header: "We are open to new collaborations",
  banner: {
    header:
      "We are open to create new blockchain products side by side with crypto-believers and entrepreneurs from this industry",
    headerMobile:
      "Are you an investor? Do yu want to find tour uicorn! Well, our plan is to became one!",
    button: "Reach us",
  },
};
